<template>
	<div>
		<form @submit.prevent="save" ref="form" enctype="multipart/form-data">
			<div class="title-container">
				<div class="title">Customize Your Theme</div>
				<div class="buttons">
					<a v-if="hasChanged" href @click.prevent="reset" class="button"><div class="hover-title">Reset</div><span class="fa fa-undo"></span></a>
					<a v-if="!savedIsDefault && !isDefault" href @click.prevent="resetToDefault" class="button"><div class="hover-title">Revert</div><span class="fa fa-sync"></span></a>
				</div>
			</div>

			{{ /* Logo */ }}
			<!--
			<div v-show="$root.isSuperAdmin && !form.file" class="input-container">
				<div class="input-title">Account Logo</div>
				<div class="input-box">
					<label for="file-upload" class="input-file-upload"><span class="fa fa-cloud-upload"></span>Choose Logo</label>
					<input id="file-upload" ref="fileInput" type="file" @change="loadImagesFromFile" name="logo">
				</div>
			</div>
			<div v-if="form.file" class="input-container">
				<div class="input-title">Logo To Upload</div>
				<div class="input-box"><input type="text" disabled :value="form.file"><span @click.prevent="clearSelectedFile" class="fa fa-times"></span></div>
			</div>
			<div v-if="hasLogo" class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="delete_logo" name="delete_logo" v-model="form.delete_logo">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="delete_logo" class="input-checkbox-text">Delete Current Logo?</label>
				</div>
			</div>
			-->

			{{ /* Icon */ }}
			<div v-show="$root.isSuperAdmin && !form.icon" class="input-container">
				<div class="input-title">Account Icon</div>
				<div class="input-box">
					<label for="mobile-logo" class="input-file-upload"><span class="fa fa-cloud-upload"></span>Choose Icon</label>
					<input id="mobile-logo" ref="iconInput" type="file" @change="loadIconFromFile" name="icon">
				</div>
			</div>
			<div v-if="form.icon" class="input-container">
				<div class="input-title">Icon To Upload</div>
				<div class="input-box"><input type="text" disabled :value="form.icon"></div>
				<div class="input-box-icon"><a @click.prevent="clearSelectedIcon"><span class="fa fa-times-circle"></span> Cancel Icon Upload</a></div>
			</div>
			<div v-if="hasIcon" class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="delete_icon" name="delete_icon" v-model="form.delete_icon">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="delete_icon" class="input-checkbox-text">Delete Current Icon?</label>
				</div>
			</div>

			<div class="grid form two">
				<div v-if="$root.isSuperAdmin" class="input-container">
					<div class="input-title">Brand Color</div>
					<div class="input-box">
						<color-picker v-model="colors.brand_color"></color-picker>
					</div>
				</div>

				<div v-if="$root.isSuperAdmin" class="input-container">
					<div class="input-title">Good Color</div>
					<div class="input-box">
						<color-picker v-model="colors.good"></color-picker>
					</div>
				</div>

				<div v-if="$root.isSuperAdmin" class="input-container">
					<div class="input-title">Neutral Color</div>
					<div class="input-box">
						<color-picker v-model="colors.neutral"></color-picker>
					</div>
				</div>

				<div v-if="$root.isSuperAdmin" class="input-container">
					<div class="input-title">Bad Color</div>
					<div class="input-box">
						<color-picker v-model="colors.bad"></color-picker>
					</div>
				</div>

				<div v-if="hasChanged" class="alert alert-general">
					<ul>
						<li><span class="fa fa-question-circle"></span>Changes or reversions will not be made permanent until you have saved.</li>
					</ul>
				</div>
			</div>
			<submit-button text="Save Changes" error-text="Failed: See Problems Above" icon="fa-save" :loading="formSaving"></submit-button>
		</form>
	</div>
</template>

<script>

import { Chrome } from 'vue-color';
import { mapGetters, mapState } from 'vuex';
import FormMixin from '@/mixins/FormMixin';
import { DEFAULTS, getDefaults } from '@/utils/colors';

export default {

	name: 'UXPage',

	mixins: [ FormMixin ],

	async asyncData({ store }) {
		const user = store.getters.currentUser || {};
		const account = store.getters.currentAccount || {};
		const colors = {
			brand_color: account.brand_color || DEFAULTS.BRAND,
			good: account.good || DEFAULTS.GOOD,
			bad: account.bad || DEFAULTS.BAD,
			neutral: account.neutral || DEFAULTS.NEUTRAL,
		};

		const extraFields = {
			icon: null,
			logo: null,
			delete_logo: false,
			delete_icon: false,
		};

		return {
			hasIcon: !!account.icon,
			hasLogo: !!account.logo,
			colors,
			form: Object.assign({}, colors, account, extraFields),
			originalForm: Object.assign({}, colors, account, extraFields),
		};
	},

	data() {
		return {
			form: { },
			originalForm: { },
			defaultForm: getDefaults(),
		};
	},

	computed: {

		...mapGetters(['currentAccount']),

		hasChanged() {
			return JSON.stringify(this.form) !== JSON.stringify(this.originalForm);
		},

		savedIsDefault() {
			return JSON.stringify(this.defaultForm) === JSON.stringify(this.originalForm);
		},

		isDefault() {
			return JSON.stringify(this.defaultForm) === JSON.stringify(this.form);
		}

	},

	watch: {

		colors: {
			deep: true,
			handler(newValue) {
				Object.keys(newValue).forEach(colorKey => {
					let formKey = colorKey;
					if (colorKey === 'brand') {
						formKey = 'brand_color';
					}
					this.form[formKey] = typeof newValue[colorKey] === 'object' ? newValue[colorKey].hex : newValue[colorKey];
				});
				this.$root.$emit('colors', this.form);
			},
		},

		form: function(newValue) {

		},

	},

	beforeDestroy() {
		this.$root.$emit('colors', this.originalForm);
	},

	methods: {

		loadImagesFromFile(ev) {
			this.$set(this.form, 'file', ev.target.files[ 0 ].name);
		},

		clearSelectedFile() {
			this.form.file = null;
			this.$refs.fileInput.value = '';
		},

		loadIconFromFile(ev) {
			this.$set(this.form, 'icon', ev.target.files[ 0 ].name);
		},

		clearSelectedIcon() {
			this.form.icon = null;
			this.$refs.iconInput.value = '';
		},

		reset() {
			this.$refs.form.reset();
			this.form = Object.assign({}, this.originalForm);
			this.colors = Object.assign({}, this.defaultForm);
		},

		resetToDefault() {
			this.$refs.form.reset();
			this.form = Object.assign({}, this.defaultForm);
			this.colors = Object.assign({}, this.defaultForm);
		},

		async save() {
			this.submit(async () => {
				const formData = new FormData(this.$refs.form);
				if (this.$root.isSuperAdmin) {
					formData.append('brand_color', this.form.brand_color);
					formData.append('good', this.form.good);
					formData.append('bad', this.form.bad);
					formData.append('neutral', this.form.neutral);
				}

				try {
					const { data } = await this.$api.post(
						'/super/accounts/ux', formData,
						{
							headers: { 'Content-Type': 'multipart/form-data' },
						}
					);

					this.$store.dispatch('addToast', 'Theme Updated');
					this.$store.dispatch('setUser', data);
					this.$store.dispatch('getAccounts');
					this.originalForm = Object.assign({}, this.form, { icon: null, logo: null, file: null });
					this.$refs.form.reset();
					this.form = Object.assign({}, this.form, { icon: null, logo: null, file: null });
				} catch (e) {
					this.$store.dispatch('errorToast', 'There was an error updating your settings. Please try again later.');
				}
			});
		},

	},

	components: {
		ColorPicker: Chrome,
	},

};

</script>
